import { Link } from "react-router-dom";
import { BrandMark } from "@/components/Brand";

export function PartnerShell({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="partner-shell">
      <header className="border-b">
        <div className="mx-auto flex max-w-5xl items-center gap-3 px-5 py-4">
          <Link to="/" aria-label="Início"><BrandMark size="h-9 w-9" /></Link>
          <div>
            <p className="font-display font-bold leading-tight">Programa de parceiros</p>
            <p className="text-xs text-muted-foreground">Indique e ganhe comissão</p>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl space-y-6 px-5 py-8">{children}</main>
    </div>
  );
}

export function Notice({ title, text, children, testId }) {
  return (
    <div className="card-surface mx-auto max-w-lg space-y-3 p-6 text-center" data-testid={testId}>
      <p className="font-display text-xl font-semibold">{title}</p>
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
      {children}
    </div>
  );
}
